import React, { Component } from "react";

import { connect } from "react-redux";
import ApplicNavbar from "./ApplicNavbar.js";

import "./navbar.scss";
class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        {/* Navbar */}
        <div className="header bg-white sticky-header sm-bshadow-20">
          <ApplicNavbar />
        </div>
        {/* End Navbar */}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps, null)(Navbar);
